<template>
  <div :class="strokeClasses" :style="strokeStyle" />
</template>

<script setup lang="ts">
import { computed, toRefs } from "vue";
import { Theme } from "@/types/types";

const props = withDefaults(
  defineProps<{
    pos: "left" | "right";
    show: boolean;
    isUmbraco?: boolean;
    theme: Theme;
  }>(),
  {
    pos: "right",
    isUmbraco: false,
  }
);

const { pos, theme, isUmbraco, show } = toRefs(props);

const background = computed(() => {
  return isUmbraco.value ? `bg-${theme.value}` : "bg-primary";
});

const strokeClasses = computed(() => {
  return `z-30 ${background.value} absolute top-0 left-0 w-full h-full`;
});

const strokeStyle = computed(() => {
  const strokePos =
    pos?.value === "left"
      ? "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)"
      : "polygon(0 0, 0 0, 0 100%, 0 100%)";
  const animation = show.value
    ? strokePos
    : "polygon(0 0, 100% 0, 100% 100%, 0 100%)";
  return {
    clipPath: animation,
    transition:
      "background-color 1s cubic-bezier(0.4, 0, 0.2, 1), clip-path 0.7s cubic-bezier(0.215, 0.61, 0.355, 1) 0.1s",
  };
});
</script>
